import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../../../../../../components/Header/Header';
import NoData from '../../../../../../components/NoData/NoData';
import chevronTable from '../../../../../../assets/icons/chevronTable.svg';
import GetItRefundDetails from '../../../../../../components/NewSideSheet/GetItRefundDetails';
import useGetIt from '../../../../../../hooks/useGetIt';
import { Loader } from '@piggytechng/component-library';
import { formatToNaira } from '../../../../../../helpers/utils';
import './index.scss';

const ViewAllGetIt = () => {
  const { activeTab, id } = useParams();
  const userId = id as string;
  const navigate = useNavigate();
  const [showRefundDetails, setShowRefundDetails] = useState(false);
  const [selectedRefund, setSelectedRefund] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const getStatusFromFilter = (filter: string) => {
    switch (filter) {
      case 'active':
        return 'active';
      case 'completed':
        return 'completed';
      case 'paused':
        return 'paused';
      case 'refund':
        return 'underfunded_refunded';
      default:
        return '';
    }
  };

  const { subscriptions, isLoading } = useGetIt({
    page: 1,
    limit: 100,
    status: getStatusFromFilter(activeTab || 'active'),
  });

  const filteredSubscriptions = subscriptions.filter(
    (item) =>
      item.reference.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.purchase.item.title.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const capitalizedTab = (activeTab || 'Active').charAt(0).toUpperCase() + (activeTab || 'Active').slice(1);

  const handleRowClick = (item: any) => {
    if (activeTab === 'refund') {
      setSelectedRefund(item);
      setShowRefundDetails(true);
    } else {
      navigate(`/view-getit/${userId}/${item.reference}/${activeTab}`);
    }
  };

  return (
    <div className="view-all-getit">
      <Header name={`${capitalizedTab} Purchases`} backButton />
      <div className="content">
        <div className="customers-filter">
          <div className="input-field">
            <form action="" onSubmit={(e) => e.preventDefault()}>
              <input
                type="text"
                placeholder="Search by ID or Product"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </form>
          </div>
          <div className="query-filter">
            <div>
              <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                  stroke="#1E293B"
                  strokeWidth="1.5"
                  strokeLinecap="square"
                />
              </svg>
            </div>
            <div>Search</div>
          </div>
          <div className="query-filter">
            <div></div>
            <div>Reset</div>
          </div>
        </div>

        {isLoading ? (
          <div
            className="flex--2"
            style={{ height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <Loader />
          </div>
        ) : filteredSubscriptions.length > 0 ? (
          <div className="getit-list">
            {filteredSubscriptions.map((item, index) => (
              <div key={index} className="getit-item pointer" onClick={() => handleRowClick(item)}>
                <div
                  className="item-thumb"
                  style={{
                    backgroundImage: `url(${item.purchase.item.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                />
                <div className="item-info">
                  <h3>{item.purchase.item.title}</h3>
                  <p className="item-id">ID: {item.reference}</p>
                  <p className="item-frequency">
                    {formatToNaira(item.amounts.per_debit_amount)} {item.payment_schedule.cadence_label}
                  </p>
                </div>
                <div className="item-cost">
                  <h4 className="total-cost">{formatToNaira(item.amounts.target_amount)}</h4>
                  <p className="end-date">Ends: {item.duration.target_date.split(' ')[0]}</p>
                </div>
                <img src={chevronTable} alt="chevron" className="chevron-table" />
              </div>
            ))}
          </div>
        ) : (
          <NoData message={searchTerm ? 'No results found for your search.' : `No ${activeTab} purchases found.`} />
        )}
      </div>

      <GetItRefundDetails show={showRefundDetails} onClose={() => setShowRefundDetails(false)} data={selectedRefund} />
    </div>
  );
};

export default ViewAllGetIt;
